module.exports = __webpack_public_path__ + "img/ba.svg.df1d823a.png";